export default "__VITE_ASSET__6a$wPg1j__"